import styled from '@emotion/styled';

export const ChoiceButton = styled.button<{ selected: boolean }>`
  padding: 10px 18px;
  color: ${({ selected }) => (selected ? '#222222' : '#595656')};
  line-height: 118%;
  font-size: 15px;
  font-weight: 400;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  letter-spacing: 0.01em;
  cursor: not-allowed;
  border: ${({ selected }) => (selected ? '1px solid #222222' : '1px solid #A09E9E')};
  border-radius: 95px;
  background-color: ${({ selected }) => (selected ? '#DDFF15' : '#E5E3E3')};

  &:hover {
    background-color: #ddff15;
  }

  ${({ theme }) => theme.multiChoiceButton};
`;

export const FindContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const MultiChoiceMessageContainer = styled.div`
  display: grid;
  align-items: stretch;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 10px;
  padding: 0 11px;
  gap: 10px 6px;
  grid-template-columns: repeat(auto-fit, minmax(calc(50% - 3px), 1fr));
  grid-auto-rows: auto;

  ${({ theme }) => theme.multiChoice};
`;

export const FindButton = styled.button`
  margin-top: 10px;
  width: 122px;
  max-width: 122px;
  height: 41px;
  max-height: 41px;
  padding: 10px 20px;
  color: #c3c2c2;
  line-height: 19.5px;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.01em;
  cursor: pointer;
  border: none;
  border-radius: 25px;
  background-color: #f2f1eff5;

  &:hover {
    color: #dbf518;
    background-color: black;
  }

  &:focus {
    color: #dbf518;
    background-color: black;
    outline: none;
  }

  &:enabled {
    margin-right: 5px;
    color: #dbf518;
    font-size: 15px; /* required to style an arrow on Safari (IOS) */
    border: 1px solid #000;
    border-radius: 25px;
    background-color: black;
  }

  &:disabled {
    font-size: 15px; /* required to style an arrow on Safari (IOS) */
    cursor: not-allowed;
    border: 1px solid #c3c2c2;
    background-color: #f2f1eff5;
  }
`;
